import { render, staticRenderFns } from "./investment-contribution-filter.vue?vue&type=template&id=06d2426c"
import script from "./investment-contribution-filter.vue?vue&type=script&lang=js"
export * from "./investment-contribution-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports